import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const DumbbellIcon = ({ size = 16, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5.9" y="7" width="3.2" height="10" rx="1.2" />
    <rect x="14.9" y="7" width="3.2" height="10" rx="1.2" />
    <path d="M9.1 12h5.8" />
    <path d="M3.2 9.8v4.4" />
    <path d="M20.8 9.8v4.4" />
  </svg>
)
